<template>
  <div>
    <v-dialog v-model="dialog" width="600" v-bind="$attrs">
      <template v-slot:activator="{ on, attrs }">
        <slot name="activator" :on="on" :attrs="attrs">
          <i-btn
            elevation="0"
            color="normal"
            outlined
            small
            class="btn-post"
            v-bind="attrs"
            v-on="on"
            >우편번호 찾기</i-btn
          >
        </slot>
      </template>

      <v-card>
        <v-card-title class="pt-7 pb-5 px-7"
          >{{ $t('우편번호 찾기') }}
          <i-btn icon light @click="dialog = false" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </i-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="box-body">
              <DaumPostcode :on-complete="oncomplete" />
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DaumPostcode from 'vuejs-daum-postcode';

export default {
  props: {
    zip: { type: String },
    address: { type: String },
    detailAddress: { type: String },
  },
  components: { DaumPostcode },
  data() {
    return {
      dialog: false,
      result: null,
    };
  },
  methods: {
    oncomplete(result) {
      this.$emit('apply', result);
      this.dialog = false;
    },
  },
};
</script>
